import * as d3 from 'd3'
export default {
  methods: {

    draw_Forms() {

      this.canvasForms = this.svg
      .append('g')
      .attr('transform', `translate(0.5, 0.5)`)
      .style('font-family', 'roboto')


      this.radio.list.forEach(d => {
      
        if(this.radio.list.length == 1) return

        let stg = this.canvasForms
        .append('g')
        .attr('id', `STG_GROUP_${d.id}_${this.localId}`)
        .attr('transform', `translate(${this.radio.x} , ${this.radio.y})`)
        .attr('opacity', d.id == this.current.id ? 1 : 0.8)
        .attr('cursor', 'pointer')
        .on('mouseover', () => { 
          d3.select(`#STG_GROUP${d.id}_${this.localId}`).attr('opacity', 0.5) 
        })
        .on('mouseout', () => { 
          d3.select(`#STG_GROUP${d.id}_${this.localId}`).attr('opacity', d == d ? 1 : 0.8) 
        })
        .on('click', ()=> {
          if(this.current.id == d.id) return
          d3.select(`#STG_GROUP${this.current.id}_${this.localId}`).attr('opacity', 0.8) 
          d3.select(`#STG_TXT_${this.current.id}_${this.localId}`).attr('font-weight', 400).attr('fill', '#333')
          d3.select(`#STG_IN_${this.current.id}_${this.localId}`).attr('fill', '#fff')

          d3.select(`#STG_GROUP${d.id}_${this.localId}`).attr('opacity', 1) 
          d3.select(`#STG_TXT_${d.id}_${this.localId}`).attr('font-weight', 500).attr('fill', '#000')
          d3.select(`#STG_IN_${d.id}_${this.localId}`).attr('fill', '#F35E90')

          this.current = d
          
          // Remove & Redraw
          this.canvasChart.remove()
          this.chart_Router() //-----> Refresh Chart
    
          this.set_selectedItems()
        })
        
        stg
        .append('circle')
        .attr('transform', `translate(0, 0.5)`)
        .attr('r', 6).attr('stroke', '#F7BACF').attr('stroke-width', 1).attr('fill', '#fff')

        stg
        .append('circle')
        .attr('id', `STG_IN_${d.id}_${this.localId}`)
        .attr('transform', `translate(0, 0.5)`)
        .attr('r', 3).attr('stroke', '#F35E90').attr('stroke-width', 0)
        .attr('fill', this.current.id == d.id ? '#F35E90' : '#fff')

        stg
        .append('text')
        .attr('id', `STG_TXT_${d.id}_${this.localId}`)
        .attr('transform', `translate(11, ${0.5 + this.radio.tSize*0.36})`)
        .attr('font-size', this.radio.tSize).attr('fill', this.radio.tColor)
        .attr('font-weight', this.current.id == d.id ? 500 : 400)
        .attr('text-anchor', 'start')
        .text(d.name)

        this.radio.x += this.getNode(`#STG_TXT_${d.id}_${this.localId}`, 'width') + 40
      })



      this.chart_Router()
      
      

      if (this.sundries) {
        let sunData = this.JQueries.sundriesConfig && this.JQueries.sundriesConfig.SQL ? this.Queries[this.JQueries.sundriesConfig.SQL][0] : this.DataItems[0]
        if(this.sundries.length > 0) this.gmx_Sundries(this.svg, this.sundries, sunData, this.JQueries.sundriesConfig.server)
      }
    },



    
      
  }
}
           